import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'donation-option',
		pluralName: 'donation-options',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
